import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Layout/Navbar";
import Footer from "@/components/Layout/Footer";
import Home from "@/pages/Home";
import Trailers from "@/pages/Trailers";
import Events from "@/pages/Events";
import HowItWorks from "@/pages/HowItWorks";
import Gallery from "@/pages/Gallery";
import ServiceArea from "@/pages/ServiceArea";
import FAQs from "@/pages/FAQs";
import Booking from "@/pages/Booking";
import BookingReceived from "@/pages/BookingReceived";
import CustomerPortal from "@/pages/CustomerPortal";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import LocationPage from "@/pages/LocationPage";
import Unsubscribe from "@/pages/Unsubscribe";
import { SEO_PAGES } from "@/lib/seoPages";
import "@/App.css";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <main className="pt-20">{children}</main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/trailers" element={<PublicLayout><Trailers /></PublicLayout>} />
          <Route path="/events" element={<PublicLayout><Events /></PublicLayout>} />
          <Route path="/how-it-works" element={<PublicLayout><HowItWorks /></PublicLayout>} />
          <Route path="/gallery" element={<PublicLayout><Gallery /></PublicLayout>} />
          <Route path="/service-area" element={<PublicLayout><ServiceArea /></PublicLayout>} />
          <Route path="/faqs" element={<PublicLayout><FAQs /></PublicLayout>} />
          <Route path="/booking" element={<PublicLayout><Booking /></PublicLayout>} />
          <Route path="/booking/received" element={<PublicLayout><BookingReceived /></PublicLayout>} />
          <Route path="/portal/:bookingId" element={<PublicLayout><CustomerPortal /></PublicLayout>} />
          <Route path="/unsubscribe" element={<PublicLayout><Unsubscribe /></PublicLayout>} />
          {SEO_PAGES.map((p) => (
            <Route key={p.slug} path={`/${p.slug}`} element={<PublicLayout><LocationPage /></PublicLayout>} />
          ))}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
